import { API_BASE } from '../../../api';

export const ENDPOINTS = {
    roles: `${API_BASE}/Roles`,
    rolById: (id) => `${API_BASE}/Roles/${id}`,

    atributos: `${API_BASE}/Atributos`,
    atributoById: (id) => `${API_BASE}/Atributos/${id}`,

    usuarioAtributo: `${API_BASE}/UsuarioAtributo`,
    usuarioAtributoById: (id) => `${API_BASE}/UsuarioAtributo/${id}`,

    operadoresABAC: `${API_BASE}/OperadoresABAC`,
    operadorABACById: (id) => `${API_BASE}/OperadoresABAC/${id}`,

    permisos: `${API_BASE}/Permisos`,
    permisoById: (id) => `${API_BASE}/Permisos/${id}`,

    recursos: `${API_BASE}/Recursos`,
    recursoById: (id) => `${API_BASE}/Recursos/${id}`,

    usuarios: `${API_BASE}/Usuarios`,
    usuarioLogout: `${API_BASE}/Usuarios/logout`,
    usuarioById: (id) => `${API_BASE}/Usuarios/${id}`,
    usuarioDesbloquear: (id) => `${API_BASE}/Usuarios/${id}/desbloquear`,
    usuariosByRol: (idRol) => `${API_BASE}/Usuarios/rol/${idRol}`,

    perfiles: `${API_BASE}/Perfiles`,
    perfilById: (id) => `${API_BASE}/Perfiles/${id}`,

    politicasAbac: `${API_BASE}/PoliticasAbac`,
    politicaAbacById: (id) => `${API_BASE}/PoliticasAbac/${id}`,

    rolesRecursosPermisos: `${API_BASE}/RolesRecursosPermisos`,
    rrpById: (id) => `${API_BASE}/RolesRecursosPermisos/${id}`,

    usuarioRol: `${API_BASE}/UsuarioRol`,
    usuarioRolById: (id) => `${API_BASE}/UsuarioRol/${id}`,
    usuarioRolByUsuarioId: (idUsuario) => `${API_BASE}/UsuarioRol/Usuario/${idUsuario}`,

    empleadosAreaNegocio: `${API_BASE}/EmpleadosAreaNegocio`,
    empleadosAreaNegocioById: (id) => `${API_BASE}/EmpleadosAreaNegocio/${id}`,

    empleadosNivelJerarquico: `${API_BASE}/EmpleadosNivelJerarquico`,
    empleadosNivelJerarquicoById: (id) => `${API_BASE}/EmpleadosNivelJerarquico/${id}`,

    empleadosProyectos: `${API_BASE}/EmpleadosProyectos`,
    empleadosProyectosById: (id) => `${API_BASE}/EmpleadosProyectos/${id}`,

    empleadosPuesto: `${API_BASE}/EmpleadosPuesto`,
    empleadosPuestoById: (id) => `${API_BASE}/EmpleadosPuesto/${id}`,

    empleadosTurnos: `${API_BASE}/EmpleadosTurnos`,
    empleadosTurnosById: (id) => `${API_BASE}/EmpleadosTurnos/${id}`,

    empleadosZonasGeograficas: `${API_BASE}/EmpleadosZonasGeograficas`,
    empleadosZonasGeograficasById: (id) => `${API_BASE}/EmpleadosZonasGeograficas/${id}`,

    modulos: `${API_BASE}/Modulos`,
    modulosById: (id) => `${API_BASE}/Modulos/${id}`,

    menus: `${API_BASE}/Menus`,
    menusById: (id) => `${API_BASE}/Menus/${id}`,
    reordenarMenus: `${API_BASE}/Menus/reordenar`,

    modulosObjetos: `${API_BASE}/ModulosPermitidos`,
    modulosObjetosById: (id) => `${API_BASE}/ModulosPermitidos/${id}`,

    menusObjetos: `${API_BASE}/MenusPermitidos`,
    menusObjetosById: (id) => `${API_BASE}/MenusPermitidos/${id}`,

    // General (copias para independencia de módulo)
    personas: `${API_BASE}/Personas`,
    personasById: (id) => `${API_BASE}/Personas/${id}`,

    empleados: `${API_BASE}/Empleados`,
    empleadosById: (id) => `${API_BASE}/Empleados/${id}`,

    puestos: `${API_BASE}/Puestos`,
    puestosSecurity: (tipo) => `${API_BASE}/Puestos/security?tipo=${tipo}`,
    puestosById: (id) => `${API_BASE}/Puestos/${id}`,

    unidadesOrgEmpleado: `${API_BASE}/UnidadesOrgEmpleado`,
    unidadesOrgEmpleadoById: (id) => `${API_BASE}/UnidadesOrgEmpleado/${id}`,
    unidadesOrgEmpleadoByUsuarioId: (idUsuario) => `${API_BASE}/UnidadesOrgEmpleado/usuario/${idUsuario}`,

    unidadesOrg: `${API_BASE}/UnidadesOrganizacionales`,
    unidadesOrgSecurity: (tipo) => `${API_BASE}/UnidadesOrganizacionales/security?tipo=${tipo}`,
    unidadesOrgById: (id) => `${API_BASE}/UnidadesOrganizacionales/${id}`,

    zonasGeograficas: `${API_BASE}/ZonasGeograficas`,
    zonasGeograficasSecurity: (tipo) => `${API_BASE}/ZonasGeograficas/security?tipo=${tipo}`,
    zonasGeograficasById: (id) => `${API_BASE}/ZonasGeograficas/${id}`,

    nivelesJerarquicos: `${API_BASE}/NivelesJerarquicos`,
    nivelesJerarquicosSecurity: (tipo) => `${API_BASE}/NivelesJerarquicos/security?tipo=${tipo}`,
    nivelesJerarquicosById: (id) => `${API_BASE}/NivelesJerarquicos/${id}`,

    areasNegocios: `${API_BASE}/AreasNegocio`,
    areasNegociosSecurity: (tipo) => `${API_BASE}/AreasNegocio/security?tipo=${tipo}`,
    areasNegociosById: (id) => `${API_BASE}/AreasNegocio/${id}`,

    turnos: `${API_BASE}/Turnos`,
    turnosSecurity: (tipo) => `${API_BASE}/Turnos/security?tipo=${tipo}`,
    turnosById: (id) => `${API_BASE}/Turnos/${id}`,

    configuracionTimeout: (userId) => `${API_BASE}/ConfiguracionesSistema/timeout/${userId}`,

    // Contexto Empresa
    empresas: `${API_BASE}/Empresas`,
    empresasUsuario: (id) => `${API_BASE}/Empresas/usuario/${id}`,

    // Limpieza de asignaciones por empresa (Unidades Org)
    unidadesOrgLimpiarEmpresa: `${API_BASE}/UnidadesOrgEmpleado/limpiar-empresa`,
}